import { useMemo } from 'react';
import SortRow from './elements/sort-row';
import FilterSidebar from './elements/filter-sidebar';
import Pagination from './elements/pagination';
import Catalog, { CatalogRenderProps } from '../../catalog';
import ProductItem from './elements/product-item';

interface CatalogProps {
    globalMode?: boolean;
}

function OniCatalog({ globalMode = false }: CatalogProps) {
    const render = useMemo(
        () =>
            ({
                query,
                sortBy,
                sortOrder,
                products,
                productsTotal,
                page,
                pageSize,
                classes,
                filters,
                filterValues,
                onSortChange,
                setPageSize,
                setPage,
                setQuery,
                setClassId,
                toggleFilterValue,
            }: CatalogRenderProps) => {
                return (
                    <table className="section" style={{ width: '100%' }}>
                        <tbody>
                            <tr className="common">
                                <td
                                    className="td-section"
                                    style={{ verticalAlign: 'top', paddingRight: '10px' }}
                                >
                                    {productsTotal > 0 ? (
                                        <>
                                            {query && (
                                                <h2 style={{ marginTop: 0 }}>Поиск по слову «{query}»</h2>
                                            )}
                                            <SortRow
                                                sortBy={sortBy}
                                                sortOrder={sortOrder}
                                                onSortChange={onSortChange}
                                            />
                                            <Pagination
                                                page={page}
                                                total={productsTotal}
                                                pageSize={pageSize}
                                                setPage={setPage}
                                                setPageSize={setPageSize}
                                            />
                                            {products.map((p) => {
                                                return <ProductItem key={p.url} {...p} />;
                                            })}
                                            <Pagination
                                                page={page}
                                                total={productsTotal}
                                                pageSize={pageSize}
                                                setPage={setPage}
                                                setPageSize={setPageSize}
                                            />
                                        </>
                                    ) : (
                                        'Товары не найдены'
                                    )}
                                </td>
                                <td
                                    className="td-filter"
                                    style={{
                                        verticalAlign: 'top',
                                        width: '200px',
                                    }}
                                >
                                    <FilterSidebar
                                        showSearch={!globalMode}
                                        setQuery={setQuery}
                                        filters={filters}
                                        filterValues={filterValues}
                                        classes={classes}
                                        setClassId={setClassId}
                                        toggleFilterValue={toggleFilterValue}
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                );
            },

        [globalMode]
    );
    return <Catalog render={render} />;
}

export default OniCatalog;
